export default "__VITE_ASSET__DotyZMiR__"